import { ImageIcon, Video } from 'lucide-react';

import { A2vAssetType, type A2vAsset } from '../../model';

export function AssetPreviewCell({ asset }: { asset: A2vAsset }) {
  if (asset.assetType === A2vAssetType.Video) {
    return (
      <span className="bg-muted flex h-5 w-7 shrink-0 items-center justify-center rounded-sm">
        <Video className="text-muted-foreground h-3.5 w-3.5" aria-hidden="true" />
      </span>
    );
  }

  if (!asset.url) {
    return (
      <span className="bg-muted flex h-5 w-7 shrink-0 items-center justify-center rounded-sm">
        <ImageIcon className="text-muted-foreground h-3.5 w-3.5" aria-hidden="true" />
      </span>
    );
  }

  return <img className="h-5 w-7 shrink-0 rounded-sm object-cover" src={asset.url} alt="" />;
}
